import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import {getMe, postPlaces} from "../../../../redux/actions";
import {Button, Form, Header} from "semantic-ui-react";
import {Editor} from "@tinymce/tinymce-react";

export const User = ({item}) => {
    const {register, handleSubmit, formState, setValue} = useForm();

    useEffect(() => {
        register('r_bio');
    }, [register])

    const onSubmit = async data => {
        try {
            const fd = new FormData()
            fd.append('id', data.id);
            fd.append('r_name', data.r_name);
            fd.append('r_bio', data.r_bio);
            if (data.r_image) {
                fd.append('r_image', data.r_image[0]);
            }

            await postPlaces(fd);
            const res = await getMe();

            sessionStorage.setItem('Data', JSON.stringify(res.data))

        } catch (e) {
            console.log(e);
        }
    };

    return <React.Fragment>
        <Header textAlign={"center"}>
            Responsável pelos Cursos
        </Header>
        <Form id={"responsibleForm"} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
            <input type={'hidden'} name={'id'} defaultValue={item.id} ref={register()}/>
            <Form.Field>
                <label>Imagem ( Tamanho 256px X 256px )</label>
                <input
                    name={'r_image'}
                    type={'file'}
                    accept={'image/*'}
                    ref={register()}
                />
            </Form.Field>

            <Form.Field>
                <label>Nome</label>
                <input
                    name={'r_name'}
                    defaultValue={item.r_name}
                    ref={register({required: true})}
                />
            </Form.Field>
            <Form.Field>
                <label>Bio</label>
                {/*<textarea*/}
                {/*    name={'r_bio'}*/}
                {/*    defaultValue={item.r_bio}*/}
                {/*    ref={register({required: true})}*/}
                {/*/>*/}

                <Editor
                    initialValue={item.r_bio || ''}
                    apiKey='2k98j4xwwxemv13rlpv08fkevjw8nq5wjq44loezdszu39mq'
                    init={{
                        height: 330,
                        menubar: false,
                        plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | help'
                    }}
                    onEditorChange={(text) => setValue('r_bio', text)}
                />
            </Form.Field>

            <Button
                fluid
                primary
                content={'Salvar'}
                disabled={formState.isSubmitting}
                loading={formState.isSubmitting}
            />
        </Form>
    </React.Fragment>
}